import { Col, Collapse, Input, Row } from "antd";
import Modal from "antd/lib/modal/Modal";
import { FieldArray, FieldArrayRenderProps, Form, Formik } from "formik";
import React, { Fragment, useEffect, useState } from "react";
import {
  PreviousPaperModel,
  PreviousPaperQuestionsModel,
} from "../../../../models/ExamModels/PreviousPaperModel/previouspaper.model";
import { PreviousPaperService } from "../../../../services/ExamService/PreviousPaperService/previouspaper.service";
import ToggleSwitch from "../../../../shared/components/ToggleSwitch";
import UIModal from "../../../../shared/components/UIModal";
import UIStepper from "../../../../shared/components/UIStepper";
import { CaretRightOutlined, MinusCircleOutlined } from "@ant-design/icons";
import Question from "../../../CourseStructure/Chapters/AddExercise/Question";
import ButtonComponent from "../../../../shared/components/ButtonComponent";
import InputField from "../../../../shared/components/InputField";
import RadioGroup from "../../../../shared/components/RadioGroup";
import Checkbox from "antd/lib/checkbox/Checkbox";
import DatePickerField from "../../../../shared/components/DatePickerField";
import moment from "moment";
const { Panel } = Collapse;
interface AddPaperProps {
  visible: boolean;
  closeModalHandler: () => void;
  paper?: any;
  examId: number;
  refreshList: Function;
  currentPageNumber: number;
}
interface PaperValues {
  title?: string;
  month?: string;
  timerOptions: string;
  correctAnswerPoint: number;
  time: number | undefined;
  penaltyPoint?: number;
  questions: QuestionType[];
  isActive?: boolean;
}

export interface QuestionType {
  question: string;
  correctAnswer: string;
  option1: string;
  option2: string;
  option3: string;
  noOptions: boolean;
  solution: string;
  questionAttachments: any;
  questionSolutionAttachments: any;
  questionOptionImages: any;
  attachment: any;
  id: number;
  imageUrl: any;
}
export const AddPaper = ({
  visible,
  closeModalHandler,
  paper,
  examId,
  refreshList,
  currentPageNumber,
}: AddPaperProps) => {
  const [stepper, setStepper] = useState(0);
  const [initialValues, setInitialValues] = useState<PaperValues>({
    title: "",
    month: "",
    timerOptions: "no_timer",
    time: 0,
    correctAnswerPoint: 0,
    penaltyPoint: 0,
    questions: [],
    isActive: false,
  });
  const [isActive, setIsActive] = useState(false);
  const [active, setActive] = useState<number[]>([]);
  const [isPenalty, setPenalty] = useState(false);
  const [paperId, setPaperId] = useState<any>();
  const [deleteIndex, setDeleteIndex] = useState();
  const TimeOptions = [
    {
      label: "No Timer",
      value: "no_timer",
    },
    {
      label: "Whole Quiz",
      value: "whole_quiz",
    },
    {
      label: "Per Question",
      value: "per_question",
    },
  ];
  const getTimeType = (selected: string) => {
    switch (selected) {
      case "whole_quiz":
        return "mins";
      case "per_question":
        return "sec";
      default:
        return "";
    }
  };

  const addPaper = (values: any) => {
    if (paper) {
      PreviousPaperService.updatePreviousPaper(
        paperId,
        { ...values, penaltyPoint: isPenalty ? values?.penaltyPoint : 0 },
        (response: PreviousPaperModel) => {
          console.log(response);
          setPaperId(response.id);
          setStepper(1);
        },
        () => {
          setStepper(0);
        }
      );
    } else {
      PreviousPaperService.createPreviousPaper(
        {
          ...values,
          isActive,
          examId: examId,
          penaltyPoint: isPenalty ? values?.penaltyPoint : 0,
        },
        (response: PreviousPaperModel) => {
          console.log(response);
          setPaperId(response.id);
          setStepper(1);
        },
        () => {
          setStepper(0);
        }
      );
    }
  };

  useEffect(() => {
    setPenalty(
      initialValues.penaltyPoint ? initialValues.penaltyPoint > 0 : false
    );
  }, [initialValues]);

  useEffect(() => {
    if (paper) {
      console.log(paper);
      setIsActive(paper?.isActive ? paper?.isActive : false);
      setPaperId(paper?.id);

      PreviousPaperService.fetchQuestionsbyPaper(
        paper?.id,
        (questions: any) => {
          console.log(paper);
          console.log(questions);
          setInitialValues({
            ...paper,
            questions,
          });
        },
        () => {}
      );
    }
  }, [paper]);

  const handleAddquestion = (arrayHelper: FieldArrayRenderProps) => {
    const initialState = {
      question: "",
      correctAnswer: "",
      option1: null,
      option2: null,
      option3: null,
      option4: null,
      image_option1: null,
      image_option2: null,
      image_option3: null,
      image_option4: null,
      noOptions: false,
      solution: "",
      questionAttachments: [],
      questionSolutionAttachments: [],
      questionOptionImages: [],
      attachment: undefined,
      imageUrl: undefined,
    };
    arrayHelper.push(initialState);
  };
  return (
    <Formik
      initialValues={initialValues}
      onSubmit={addPaper}
      enableReinitialize
    >
      {({ values, setFieldValue, resetForm }) => (
        <Modal
          visible={visible}
          className="ui-modal"
          onCancel={closeModalHandler}
          afterClose={() => {
            resetForm();
          }}
        >
          <Form placeholder={undefined} onPointerEnterCapture={undefined} onPointerLeaveCapture={undefined}>
            <div className="board-form__title add-content-modal__title">
              {paper ? "Edit Paper" : "Add New Paper"}
            </div>
            <div className="stepper__wrapper">
              <Row>
                <Col span={10}>
                  <UIStepper current={stepper} />
                </Col>
              </Row>
            </div>
            {stepper ? (
              <FieldArray
                name="questions"
                render={(arrayHelper) => (
                  <Fragment>
                    <Collapse
                      accordion
                      bordered={false}
                      activeKey={active}
                      className="pj-list-question__collapse"
                      onChange={(key) => {
                        setActive([parseInt(key as string)]);
                      }}
                      expandIcon={({ isActive }) => (
                        <CaretRightOutlined
                          className="collapse-icon__question"
                          rotate={isActive ? 90 : 0}
                        />
                      )}
                      destroyInactivePanel
                    >
                      {values?.questions?.map((_, index) => (
                        <Panel
                          header={`Question ${index + 1}`}
                          key={index}
                          className="site-collapse-custom-panel"
                          extra={
                            <MinusCircleOutlined
                              className="pj-remove-minus__question"
                              onClick={(event) => {
                                if (values?.questions[index]?.id) {
                                const question: PreviousPaperQuestionsModel =
                                  values?.questions[index];
                                PreviousPaperService.deletePaperQuestion(
                                  question.id,
                                  () => {
                                    const questions = values.questions;
                                    questions?.splice(index, 1);
                                    setFieldValue("questions", questions);
                                  },
                                  () => {}
                                );
                                event?.stopPropagation();
                                }
                              }}
                            />
                          }
                        >
                          <Question
                            index={index}
                            exerciseId={paperId || paper.id}
                            deleteIndex={deleteIndex}
                            value={values.questions[index]}
                            setFieldValue={setFieldValue}
                            showAttachment
                            onCreate={(question, index) => {
                              setActive([-1]);

                              setFieldValue(
                                "questions",
                                [...values?.questions]?.map((ques, i) => {
                                  if (i === index) {
                                    return {
                                      ...question,
                                      imageUrl: ques?.imageUrl,
                                    };
                                  }
                                  return ques;
                                })
                              );
                            }}
                          />
                        </Panel>
                      ))}
                    </Collapse>
                    <ButtonComponent
                      className="pj-add-question"
                      type="ghost"
                      buttonContent="+ Add Question"
                      onClick={() => {
                        setActive([values?.questions?.length]);
                        handleAddquestion(arrayHelper);
                      }}
                    />
                  </Fragment>
                )}
              />
            ) : (
              <Fragment>
                <InputField
                  type="text"
                  name="title"
                  title="Paper name"
                  placeholder="Type paper name"
                  className="mt-5"
                />
                <DatePickerField
                  value={
                    paper
                      ? `${paper.month} ${paper.year}`
                      : null
                  }
                  name="month"
                  title="Exam month & year"
                  placeholder="Select date"
                  className="mt-5"
                  format={"MMM YYYY"}
                  onSelect={(date) => {
                    setFieldValue("month", date?.month());
                    setFieldValue("year", date?.year());
                  }}
                />
                <InputField
                  type="number"
                  name="correctAnswerPoint"
                  title="Points per correct answer"
                  placeholder="0"
                  className="mt-5"
                />
                <div className="mt-5">
                  <Checkbox
                    value={isPenalty}
                    checked={isPenalty}
                    onChange={({ target: { checked } }) => {
                      setPenalty(checked);
                    }}
                  />{" "}
                  &nbsp;&nbsp; Has penalty for wrong answers
                </div>
                {isPenalty && (
                  <InputField
                    type="number"
                    name="penaltyPoint"
                    title="Penalty"
                    placeholder="0"
                    className="mt-5"
                  />
                )}

                <RadioGroup
                  title="Timer Options"
                  name="timerOptions"
                  options={TimeOptions}
                  displayType="space-between"
                  className="mt-5"
                  value={values?.timerOptions}
                  selectedHandler={(selected: string) => {
                    setFieldValue("timerOptions", selected);
                  }}
                />
                <div className="time-selector mt-5">
                  <label htmlFor="time">Time</label>
                  <Input.Group compact className="time__select mt-3">
                    <Input
                      style={{ width: "10%" }}
                      disabled={values?.timerOptions === "no_timer"}
                      type="number"
                      value={values.time ?? 0}
                      onChange={({ target: { value } }) => {
                        console.log(value);
                        setFieldValue("time", parseFloat(value));
                      }}
                    />

                    <Input
                      style={{ width: "90%" }}
                      value={getTimeType(values?.timerOptions)}
                      disabled={true}
                    />
                  </Input.Group>
                </div>
                <div className="mt-5">
                  Status&nbsp;&nbsp;{" "}
                  <ToggleSwitch
                    checked={isActive}
                    handleChange={(checked: any) => {
                      setIsActive(checked);
                      if (paper) {
                        PreviousPaperService.updatePreviousPaper(
                          paper.id,
                          {
                            isActive: checked,
                          },
                          () => {},
                          () => {}
                        );
                      }
                    }}
                  />
                </div>
              </Fragment>
            )}
          </Form>
          <div className="pj-modal__controllers">
            <ButtonComponent
              buttonContent={"Cancel"}
              htmlType={"button"}
              onClick={() => {
                if (!paper && stepper) {
                  PreviousPaperService.deletePreviousPaper(
                    paperId,
                    () => {
                      setStepper(0);
                      closeModalHandler();
                    },
                    () => {}
                  );
                } else {
                  setStepper(0);
                  closeModalHandler();
                }
              }}
              type="text"
            />
            <ButtonComponent
              buttonContent={stepper ? "Finish" : "Next"}
              htmlType={"button"}
              onClick={() => {
                console.log(values);
                if (!stepper) {
                  addPaper(values as any);
                  return;
                }
                closeModalHandler();
                refreshList(currentPageNumber);
                setStepper(stepper ? 0 : 1);
              }}
              type="primary"
            />
          </div>
        </Modal>
      )}
    </Formik>
  );
};
